import { SET_SEARCH_STRING } from './constants'

export default (state = {}, action) => {
    let newState
    switch (action.type) {
        case SET_SEARCH_STRING:
            {
                const { payload } = action

                newState = { ...state, userSearchString: payload }
            }
            break
        default:
            newState = state
    }

    return newState
}
